import { useClientPortalConfigContext } from "../../context/ClientPortalConfig.ctx";
import { useGetQuery, useDefaultHandleAxiosErrorProps } from "../../hooks/useClientPortalQuery";
import { InvoiceItemModel, InvoicePayErrorApiDetailsErrorResponse } from "../../types/generated/models";
import { AxiosError } from "axios";
import { useClientPortalNavigate } from "../../hooks/useClientPortalRouter";
import { ROUTES } from "../../routes";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { ErrorProps, handleAxiosError } from "../../hooks/useClientPortalQuery.helpers";

interface IStatementDetailsHook {
    statement?: InvoiceItemModel | null;
    statementLoading: boolean;
    fetchStatement?: () => Promise<{ data?: InvoiceItemModel }>;
}

export function useStatementViewDetails(uniqueIdentifier: string | null): IStatementDetailsHook {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const navigateTo = useClientPortalNavigate();
    const defaultHandleAxiosErrorProps = useDefaultHandleAxiosErrorProps();

    const queryParams = new URLSearchParams({ id: uniqueIdentifier });

    const { data, isLoading, refetch } = useGetQuery<InvoiceItemModel | null>({
        url: `/api/v1/${clientPortalGuid}/Invoices/ViewStatement?${queryParams}`,
        handleCustomError: (error: AxiosError) => {
            const response = error.response?.data as InvoicePayErrorApiDetailsErrorResponse;
            if (response.details) {
                if (response?.details?.redirectToInvoicesPage) {
                    if (clientPortalConfig.userLoggedIn) {
                        navigateTo(ROUTES.INVOICES.urlPath);
                    } else {
                        navigateTo(ROUTES.HOME.urlPath);
                    }
                }

                enqueueSnackbar(`${response.message}`, {
                    variant: "error",
                    alertTitle: response.details.title,
                });
            } else {
                handleAxiosError({ ...defaultHandleAxiosErrorProps, error } as ErrorProps);
            }
        },
        options: {
            enabled: !!uniqueIdentifier,
        },
    });

    return {
        statement: data,
        statementLoading: isLoading,
        fetchStatement: refetch,
    };
}
